export default __webpack_public_path__ + "static/media/abstracto41440.88a73ba7.jpg";